import { Card, Table } from 'react-bootstrap';
import Footer from './home/Footer';
import Header from './home/Header';
import { TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../utils/logout';
import { ImExit } from 'react-icons/im';
import { Navigate, useNavigate } from 'react-router-dom';
import { adminDashboard } from '../features/dashboard/dashboardSlice';
const SuperAdminPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dashboardData, setDashboardData] = useState([]);
  const isAdmin = useSelector((state) => state.auth.isAdmin);
  async function getDetails() {
    try {
      const response = await dispatch(adminDashboard()).unwrap();
      setDashboardData(response.data);
    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    getDetails();
  }, []);
  if (!isAdmin) return <Navigate to='/admin/signin' replace />;
  return (
    <>
      <div className='h-full   flex flex-col overflow-auto '>
        <Header />
        <div className='text-center w-full bg-gray-100'>
          <button
            onClick={async () => {
              localStorage.setItem('userName', null);
              await logout();
              navigate('/admin/signin');
            }}
            className='text-left px-4 py-2 text-sm hover:bg-gray-100 text-red-600 flex items-center gap-2  ml-auto'
          >
            <ImExit size={20} className='text-red-600' /> Logout
          </button>
        </div>
        <div className='items-center justify-center bg-gray-100 h-[calc(100vh-132px)] p-8 max-md:p-2'>
          <Card className='lg:col-span-2 pl-4 ' sx={{ borderRadius: '10px' }}>
            <div className=' overflow-x-auto mt-4'>
              <h2 className='font-medium'>List of Application Requests </h2>
              <Table className=' m-0 mt-4 min-w-[700px]' size='small'>
                <TableHead>
                  <TableRow
                    className='p-2'
                    sx={{
                      padding: '3px',
                      '& .MuiTableCell-root': {
                        fontWeight: 'bold',
                        padding: 0,
                        paddingY: '5px',
                        // backgroundColor: '#f9fafb', // light gray header
                      },
                    }}
                  >
                    <TableCell>Institute Name</TableCell>
                    <TableCell>Location</TableCell>
                    <TableCell>Email ID</TableCell>
                    <TableCell>Mobile Number</TableCell>
                    <TableCell>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dashboardData?.map((institute) => (
                    <TableRow
                      key={institute.id}
                      className='cursor-pointer hover:bg-gray-50'
                      sx={{
                        '& .MuiTableCell-root': {
                          fontWeight: 'light',
                          padding: 0,
                          paddingY: '5px',
                        },
                      }}
                    >
                      <TableCell>{institute.instituteName}</TableCell>
                      <TableCell>{institute.location}</TableCell>
                      <TableCell>{institute.emailId}</TableCell>
                      <TableCell>{institute.phoneNumber}</TableCell>
                      <TableCell>
                        {institute.status ? (
                          <button className='border px-4 py-1 rounded-lg'>
                            Yes
                          </button>
                        ) : (
                          <button className='border px-4 py-1 rounded-lg'>
                            No
                          </button>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                  {!dashboardData.length > 0 && (
                    <TableRow>
                      <TableCell colSpan={6} sx={{ textAlign: 'center' }}>
                        No Applications
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          </Card>
        </div>
        <Footer />
      </div>
    </>
  );
};
export default SuperAdminPage;
